import styled from "styled-components";

export const ErrorMessage = styled.p`
    color: ${props => props.theme.palette.error.medium};
    background-color: ${props => props.theme.palette.error.contrastText};
    padding: 0.3rem 1rem;
    border-radius: 0.5rem;
    margin-left: auto;
    margin-right: auto;
    width: fit-content;
    max-width: 50%;
    font-size: 0.75rem;
`;